<template lang="pug">
  .section#crew
      p(v-if="crew") {{crew.name}}

</template>

<script>
export default {
  name: "CrewDisplay",
  props: {
    crew: null
  }
};
</script>

<style scoped lang="less">
#crew {
  padding-top: 0px;
  padding-bottom: 1rem;
  text-align: left;
  background-color: #333;
  color: white;
}
</style>
